import { AnchorButton, Button, Card, Classes, Icon, Intent, Tooltip } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { channelById } from '../../../../../../constants/Channels'
import { usePermissions } from '../../../../../../hooks/usePermissions'
import { UprightStyle } from '../../../../../../types'
import '../../style.scss'
import { Listing } from '../../types'
import { ChannelCard } from '../ChannelCard'
import { ListingInfo } from '../ListingInfo'

interface Props {
  pastListings: Listing[]
}

const styles: UprightStyle = {
  arrow: {
    margin: '15px 0'
  },
  stepCard: {
    padding: 10,
    textAlign: 'left'
  },
  channelName: {
    marginBottom: 4
  }
}

export const PastListingSection: React.FC<Props> = props => {
  const { permissions } = usePermissions()
  return (
    <>
      {props.pastListings.map(listing => {
        const channel = channelById(listing.marketId)
        return (
          <div style={styles.pastListings}>
            <Icon icon={IconNames.ARROW_UP} style={styles.arrow} className={Classes.TEXT_MUTED} />
            <Card style={styles.stepCard}>
              <ChannelCard channelId={listing.marketId}>
                <div>
                  <div style={styles.channelName}>
                    <b>{channel.humanReadableName}</b>
                  </div>
                  <ListingInfo listing={listing} />
                </div>
                {channel.name !== 'offer_up' && permissions.includes('products.post') && (
                  <Link to={`/listings/${channel.name}/${listing.listingId}/edit`}>
                    <Button text="Edit" minimal intent={Intent.PRIMARY} />
                  </Link>
                )}
                {channel.name === 'offer_up' && permissions.includes('products.post') && (
                  <Tooltip content="Channel no longer available">
                    <AnchorButton disabled text="Edit" minimal intent={Intent.PRIMARY} />
                  </Tooltip>
                )}
              </ChannelCard>
            </Card>
          </div>
        )
      })}
    </>
  )
}
